import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { styled as muiStyled } from "@mui/system";

export const RootContainer = muiStyled(Box)({
  height: "100%",
  overflow: "hidden",
});

export const HeaderContainer = muiStyled(Box)({
  fontFamily: "Poppins",
  fontSize: "18px",
  height: "40px",
  textAlign: "initial",
});

export const BodyContainer = muiStyled(Box)({
  height: "calc(100% - 40px)",
  overflowY: "auto",
});

export const TypeSectionContainer = muiStyled(Grid)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  display: "flex",
  alignItems: theme.isLargeScreen ? "center" : "flex-start",
  justifyContent: theme.isLargeScreen ? "flex-start" : "center",
  flexDirection: theme.isLargeScreen ? "row" : "column",
  width: "100%",
}));

export const TypeTitleSectionContainer = muiStyled(Box)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  fontFamily: "Poppins",
  fontSize: "14px",
  marginRight: theme.isLargeScreen ? "15%" : "0px",
  marginBottom: theme.isLargeScreen ? "0px" : "10px",
}));

export const CommonSectionContainer = muiStyled(Grid)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  display: "flex",
  alignItems: theme.isLargeScreen ? "center" : "flex-start",
  justifyContent: theme.isLargeScreen ? "flex-start" : "center",
  flexDirection: theme.isLargeScreen ? "row" : "column",
  marginTop: "10px",
}));

export const CommonTitleSectionContainer = muiStyled(Box)<{
  isLargeScreen?: Boolean;
}>((theme: any) => ({
  fontFamily: "Poppins",
  fontSize: "14px",
  marginRight: theme.isLargeScreen ? "15%" : "0px",
  marginBottom: theme.isLargeScreen ? "7px" : "12px",
  marginTop: theme.isLargeScreen ? "7px" : "12px",
}));

export const RadioSectionContainer = muiStyled(Grid)({
  display: "flex",
  alignItems: "center",
  margin: "10px 0px",
});

export const RadioTitleSectionContainer = muiStyled(Box)({
  fontFamily: "Poppins",
  fontSize: "14px",
  width: 200,
});

export const TextboxSectionContainer = muiStyled(Grid)({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  flexDirection: "column",
  marginTop: "10px",
});

export const ScoreTextboxSectionContainer = muiStyled(Grid)({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  marginBottom: "10px",
  marginTop: "10px",
});

export const TitleSectionContainer = muiStyled(Box)({
  marginRight: "30px",
  fontFamily: "Poppins",
  fontSize: "14px",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center"
});

export const TextboxTitleSectionContainer = muiStyled(Box)({
  marginBottom: "10px",
  fontFamily: "Poppins",
  fontSize: "14px",
});

export const OptionTextContainer = muiStyled(Box)({
  marginBottom: "10px",
  fontFamily: "Poppins",
  fontSize: "14px",
  display: "flex",
  alignItems: "center",
});

export const APIMethodContainer = muiStyled(Box)({
  color: "green",
  fontFamily: "Poppins",
  fontSize: "14px",
  fontWeight: "600",
});

export const OptionSpacing = styled("div")({
  marginTop: "10px",
});
